import CurrencyCell from "../components/CurrencyCell";
import { daysInCurrentMonth } from "../helpers";

const futureMonthColDef = [
  {
    headerName: "",
    headerClass: "primary",
    children: [
      {
        field: "id",
        hide: true,
      },
      {
        headerClass: "primary",
        field: "Warehouse",
        width: 130,
        enableRowGroup: true,
        enablePivot: true,
        pinned: true,
        editable: true,
        filter: "text",
      },
      {
        headerClass: "primary",
        headerName: "Channel",
        field: "OutletType",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        editable: true,
        pinned: true,
        filter: "text",
      },

      {
        headerClass: "primary",
        field: "Pricelist",
        width: 175,
        enableRowGroup: true,
        enablePivot: true,
        pinned: true,
        filter: "text",
      },
      {
        headerClass: "primary",
        headerName: "Product",
        field: "ProductCode",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        pinned: true,
        filter: "text",
        hide: true,
      },
      {
        headerClass: "primary",
        headerName: "Product",
        field: "Product_Name",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        pinned: true,
        filter: "agSetColumnFilter",
        filterParams: {
          keyCreator: (params) => {
            return params.data?.ProductCode || "";
          },
          valueFormatter: (params) => {
            return params.value || "(blank)";
          },
        },
        valueFormatter: (params) => {
          return params.value || "";
        },
      },
      {
        headerClass: "primary",
        field: "M2",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "M1",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "AOP",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "M",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
    ],
  },
];

var numberOfDaysInCurrentMonth = daysInCurrentMonth();

for (let day = 1; day <= numberOfDaysInCurrentMonth; day++) {
  futureMonthColDef[0].children.push({
    headerClass: "primary",
    field: String(day), // Dynamic field name
    width: 120,
    enablePivot: true,
    editable: false,
    aggFunc: "sum",
    cellRenderer: CurrencyCell,
    type: "rightAligned",
  });
}

export { futureMonthColDef };
